module.exports = __webpack_public_path__ + "static/media/Scenario5Two.f8a995e2.jpg";